var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CTabs',{attrs:{"active-tab":_vm.activeTab}},[_c('CTab',{attrs:{"title":"薬局ユーザ","to":{ name: '薬局ユーザ新規作成' }}},[_c('router-view')],1),_c('CTab',{attrs:{"title":"管理者ユーザ","to":{ name: '管理者ユーザ新規作成' }}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }